import styled from 'styled-components';

export const $PaginationContainer = styled.div`
  overflow: visible;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  margin-top: 1rem;
  margin-bottom: 1rem;

  && > div {
    margin-top: 0;
  }
`;
